import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Page = ({ children, className = "" }) => (
  <motion.main
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.55, ease: EASE }}
    className={className}
  >
    {children}
  </motion.main>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children }) => (
  <div className="flex items-center gap-4">
    <span className="h-px w-10 bg-gold" />
    <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold">
      {children}
    </span>
  </div>
);

export const Marquee = ({ items, dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y py-5 ${
      dark
        ? "bg-obsidian text-ivory/60 border-white/10"
        : "bg-cream text-obsidian/50 border-black/5"
    }`}
  >
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((i) => (
        <div key={i} className="flex items-center" aria-hidden={i === 1}>
          {items.map((t, j) => (
            <span key={j} className="flex items-center">
              <span className="font-serif italic text-xl md:text-2xl px-8">{t}</span>
              <span className="text-gold font-mono text-xs">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
